export default __webpack_public_path__ + "static/media/about-eight-bg.d1d4237d.png";